export default {
  loading: false,
  exerciseDefinitions: [],
  dialogExerciseDefinitions: [],
  exerciseDefinition: null,
  pagination: {},
  dialogPagination: {},
  exercisesFilters: {},
  dialogExercisesFilters: {},
  sequencesFilters: {},
  dialogSequencesFilters: {},
  sequenceDefinitions: [],
  dialogSequenceDefinitions: [],
  sequenceDefinition: {},
  reloadTimeoutSequence: false,
  reloadTimeoutExercises: false,
  reloadTimeoutDialogExercises: false,
  exerciseFolders: [],
  sequenceFolders: [],
  sharingCompanies: [],
  profilePreviews: [],
  routineDefinitionFoldersSharedList: [],
  duplicatedCompanies: [],
  loadingSequenceDefinitionParticipants: false,
  sequenceDefinitionParticipants: [],
  sequenceDefinitionParticipantsPagination: {},
}
